/* eslint-disable @typescript-eslint/naming-convention */
/* eslint-disable @typescript-eslint/no-explicit-any */
import { useRouter } from "next/router";
import React, { FC } from "react";
import CircularProgress from "@mui/material/CircularProgress";

import Head from "next/head";
import useDomLoaded from "hooks/use-dom-loaded";

import styles from "./styles.module.scss";
import PaymentPlan from "../PaymentPlan";
import AccountDetails from "../AccountDetails";
import PaymentConfirmation from "../PaymentConfirmation";
import Logo from "../../../../../public/full-logo-primary.svg";

type Props = {
  plan: "BASIC" | "PRO" | "DISCOUNT";
  goToChat?: boolean;
  variant?: "INSPECTION" | "URL_DERIVED" | "PRO_REFERRAL";
};

const LeadFlow: FC<Props> = ({ plan, goToChat, variant }) => {
  const domLoaded = useDomLoaded();

  const router = useRouter();

  const { query, isReady } = router;
  const { zip, pid, success } = query;

  const steps = [PaymentPlan, AccountDetails, PaymentConfirmation];

  const stepIndex = success ? 2 : pid ? 1 : zip ? 1 : 0;
  const props = { goToChat, variant, plan, isSuccess: success === "true" };
  const Step = steps[stepIndex];

  return (
    <div className={styles.wrapper}>
      <Head>
        <title>Sign Up | Humming Homes</title>
        <meta
          name="description"
          content="Begin the Humming Homes onboarding flow and sign up"
        />
        <link rel="icon" href="/favicon.ico" />
      </Head>
      <div className={styles.logoContainer}>
        <Logo
          className={styles.logo}
          onClick={() => {
            router.push("/");
          }}
        />
      </div>
      {domLoaded && isReady ? (
        <Step {...props} />
      ) : (
        <div className={styles.loadingWrapper}>
          <CircularProgress className={styles.spinner} />
        </div>
      )}
    </div>
  );
};

export default LeadFlow;
